module.exports = __webpack_public_path__ + "static/media/ky.18cdf70c.svg";